import { usePreset } from '@primeuix/themes';
import { BasePreset } from '../../themes/base';
import {
    ThemeBlue,
    ThemeGreen,
    ThemeBordeaux,
    ThemeOrange,
    ThemeBrown,
    ThemeGray,
    ThemeRed,
    ThemeYellow,
    ThemeTeal,
    ThemePink,
    ThemeIndigo,
    ThemeCyan,
    ThemeLime,
    ThemeAmber,
    ThemeSky,
    ThemeStone,
    ThemeEmerald,
} from '../../themes/variants';

const registry = {
    base: BasePreset,
    blue: ThemeBlue,
    green: ThemeGreen,
    bordeaux: ThemeBordeaux,
    orange: ThemeOrange,
    brown: ThemeBrown,
    gray: ThemeGray,
    red: ThemeRed,
    yellow: ThemeYellow,
    teal: ThemeTeal,
    pink: ThemePink,
    indigo: ThemeIndigo,
    cyan: ThemeCyan,
    lime: ThemeLime,
    amber: ThemeAmber,
    sky: ThemeSky,
    stone: ThemeStone,
    emerald: ThemeEmerald,
};

const STORAGE_KEY = 'app-theme';

export function useThemeSwitcher() {
    const current = useState('theme-current', () => 'base');

    function apply(key) {
        const preset = registry[key] || BasePreset;
        usePreset(preset);
        current.value = key;
        if (process.client) localStorage.setItem(STORAGE_KEY, key);
    }

    function loadSaved() {
        if (!process.client) return;
        const saved = localStorage.getItem(STORAGE_KEY) || 'base';
        apply(saved);
    }

    return { current, apply, loadSaved, registry };
}
